import { cn } from 'components/UI/cn'

/**
 * Gmail-style shell for the inline reply composer: user avatar on the left,
 * a rounded card with border + shadow on the right. Caps height with a scroll
 * region so long drafts stay within a reasonable footprint.
 *
 * Shared between the company email inbox (`ComposePanel` in inline mode) and
 * the campaign reply inbox (`ReplyComposePanel`) so the two experiences look
 * and behave identically.
 */
export function InlineComposeShell({
  userInitials,
  maxHeightClass = 'max-h-[50vh]',
  children,
}: {
  /** 1–2 character initials shown in the avatar bubble. */
  userInitials: string
  /** Tailwind max-height class for the card. Defaults to `max-h-[50vh]`. */
  maxHeightClass?: string
  children: React.ReactNode
}) {
  return (
    <div className="border-t border-line-subtle px-6 py-4">
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-full bg-fg-muted flex items-center justify-center flex-shrink-0 mt-1">
          <span className="text-white font-bold text-sm">{userInitials}</span>
        </div>
        <div
          className={cn(
            'flex-1 rounded-xl border border-line-subtle bg-surface flex flex-col',
            'shadow-[0px_2px_6px_rgba(0,0,0,0.15),0px_1px_2px_rgba(0,0,0,0.3)]',
            maxHeightClass
          )}
        >
          {children}
        </div>
      </div>
    </div>
  )
}
